import PropTypes from 'prop-types'
import { Fragment } from 'react'
import {
  MARGIN_BOTTOM_TITLE_PANEL,
  MARGIN_TOP_NOTE,
  MARGIN_TOP_TITLE_PANEL,
  TYPE_ITEM_PDF,
  WIDTH_PDF_LANSCAPE_WITHOUT_PADDING,
  WIDTH_PDF_PORTRAIT_WITHOUT_PADDING,
} from '../constant'
import { getIdToc } from '../helper'
import { DownloadPdfFile } from './DownloadPdfFile'

const PdfDataToPdfFile = ({ data, setDefault, typeDownload, coverPage }) => {
  return (
    <DownloadPdfFile
      setDefault={setDefault}
      typeDownload={typeDownload}
      coverPage={coverPage}
      data={data}
    >
      {() => {
        return (
          <>
            {data.map(({ page, items, isLandscape }) => {
              const widthPage = isLandscape
                ? WIDTH_PDF_LANSCAPE_WITHOUT_PADDING
                : WIDTH_PDF_PORTRAIT_WITHOUT_PADDING

              return (
                <div
                  style={{ width: widthPage }}
                  data-pdfmake={`{"pageBreak": "before", "pageOrientation": "${
                    isLandscape ? 'landscape' : 'portrait'
                  }"}`}
                  key={page}
                >
                  {items.map((item, index) => {
                    if (item.type === TYPE_ITEM_PDF.CHAPTER_HEADER) {
                      return (
                        <img
                          key={index}
                          src={item.img}
                          alt="img"
                          style={{ width: widthPage }}
                          data-pdfmake={`{"id": "${getIdToc(
                            page,
                            index,
                          )}", "text": "${item.title?.toUpperCase()}"}`}
                        />
                      )
                    }

                    if (item.type === TYPE_ITEM_PDF.TITLE_PANEL) {
                      return (
                        <img
                          key={index}
                          src={item.img}
                          alt="img"
                          style={{
                            width: widthPage,
                            marginTop: index ? MARGIN_TOP_TITLE_PANEL : 0,
                            marginBottom: MARGIN_BOTTOM_TITLE_PANEL,
                          }}
                          data-pdfmake={`{"id": "${getIdToc(
                            page,
                            index,
                          )}", "text": "${item.title}"}`}
                        />
                      )
                    }
                    if (item.type === TYPE_ITEM_PDF.CONTENT_PANEL) {
                      return (
                        <img
                          key={index}
                          src={item.img}
                          alt="img"
                          style={{ width: widthPage }}
                          data-pdfmake={
                            item.title
                              ? `{"id": "${getIdToc(page, index)}", "text": "${
                                  item.title
                                }"}`
                              : undefined
                          }
                        />
                      )
                    }
                    if (item.type === TYPE_ITEM_PDF.NOTE) {
                      return (
                        <img
                          key={index}
                          src={item.img}
                          alt="img"
                          style={{
                            width: widthPage,
                            marginTop: index ? MARGIN_TOP_NOTE : 0,
                          }}
                        />
                      )
                    }
                    return <Fragment key={index} />
                  })}
                </div>
              )
            })}
          </>
        )
      }}
    </DownloadPdfFile>
  )
}

PdfDataToPdfFile.propTypes = {
  data: PropTypes.array.isRequired,
  setDefault: PropTypes.func.isRequired,
  typeDownload: PropTypes.string,
  coverPage: PropTypes.object.isRequired,
}

export default PdfDataToPdfFile
